import {CREATE_NOTIFICATION_START} from "../../types";

export const create_notification = (payload) => ({
  type: CREATE_NOTIFICATION_START,
  payload,
});
